/* eslint-disable no-alert */
import { FunctionComponent } from 'react'
import { Box, Button, Link, Typography, useMediaQuery } from '@mui/material'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import { loadStripe, Stripe } from '@stripe/stripe-js'

import { useAuth0 } from '@auth0/auth0-react'
import theme from 'src/theme'

// eslint-disable-next-line fp/no-nil
let stripePromise: Promise<Stripe | null>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getStripe = () => {
  if (!stripePromise) {
    // eslint-disable-next-line fp/no-mutation,@typescript-eslint/no-non-null-assertion
    stripePromise = loadStripe(
      import.meta.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!,
    )
  }
  return stripePromise
}

let Register: FunctionComponent = () => {
  let isPhone = useMediaQuery(theme.breakpoints.down('sm'))

  let { loginWithRedirect } = useAuth0()

  let transition = 'font-size 100ms ease-in-out'

  return (
    <Box sx={{ height: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          flexGrow: 1,
          position: 'relative',
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            opacity: 0.12,
            background: 'url(/home-background.jpeg)',
            backgroundSize: 'cover',
            zIndex: 1,
          },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1,
              px: 3,
              pt: 1,
            }}
          >
            <img
              src="/background.svg"
              style={{ height: 60, width: 60, flexGrow: 0 }}
            />
            <Box sx={{ flexGrow: 1 }}></Box>
            <Typography variant="h5" fontFamily="smileAndWave" sx={{ p: 1 }}>
              User Registration
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ maxWidth: 540, px: 2 }}>
              <Typography
                sx={{
                  textAlign: 'center',
                  fontSize: isPhone ? 18 : 24,
                  mb: 2,
                  mt: 1,
                  transition,
                }}
              >
                It's time to start enjoying Continuing Education!
              </Typography>
              <Box
                sx={{
                  p: 3,
                  border: `1px solid ${theme.palette.primary.dark}`,
                  borderRadius: 3,
                  background: theme.palette.background.default,
                  boxShadow: `0px 0px 10px 10px ${theme.palette.background.default}`,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    mt: 1.5,
                    mb: 3.5,
                  }}
                >
                  Only $159.99!
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {[
                    'Get instant access to FOAMfrat Studio',
                    '200+ hours of CAPCE & ANCC accredited content',
                    'Live classes Monday-Friday',
                    'CAPCE & ANCC Accredited',
                    'IBSC Approved FP-C / CCP-C 40 & 100 Hour Refresher',
                    'Credential Tracking & Management',
                  ].map((benefit) => (
                    <Box key={benefit} sx={{ display: 'flex', gap: 1 }}>
                      <TaskAltIcon color="primary" />
                      <Typography>{benefit}</Typography>
                    </Box>
                  ))}
                </Box>
                <Typography
                  sx={{
                    textAlign: 'center',
                    fontSize: 16,
                    mt: 4,
                    mb: 2,
                    fontWeight: 'bold',
                  }}
                >
                  Get started today!
                </Typography>
                <Box
                  sx={{
                    px: 3,
                    mt: 3,
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    sx={{ py: 1, mb: 1 }}
                    className="w-3/4"
                    variant="contained"
                    color="secondary"
                    onClick={() =>
                      loginWithRedirect({
                        authorizationParams: { screen_hint: 'signup' },
                      })
                    }
                  >
                    Create Your Account
                  </Button>
                </Box>
                <Typography
                  sx={{ textAlign: 'center', fontSize: 14, mt: 2, mb: 1 }}
                >
                  Already have an account?{' '}
                  <Link
                    color="primary"
                    sx={{ cursor: 'pointer' }}
                    onClick={() => loginWithRedirect()}
                  >
                    Sign In
                  </Link>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 2,
          gap: 1,
        }}
      >
        <Typography sx={{ fontSize: isPhone ? 14 : 16, mb: 2 }}>
          By creating an account, you agree to our Privacy Policy and Terms and
          Conditions:
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            background: '#101010',
          }}
        >
          <Button
            size="large"
            variant="outlined"
            color="primary"
            className="text-reset"
            href="https://www.foamfrat.com/privacy-policy"
            target="_blank"
          >
            Privacy Policy
          </Button>
          <Button
            size="large"
            variant="outlined"
            color="primary"
            className="text-reset"
            href="https://www.foamfrat.com/termsofservice"
            target="_blank"
          >
            Terms & Conditions
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default Register
